import { mapState, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceFunctionDetailFollow',
  components: {
    Loading,
    FileSelectorButton
  },
  data () {
    return {
      loading: true,
      processing: false,

      // input
      inpAnswer1: null,
      inpAnswer2: null,
      inpAnswer3: null,
      inpAnswer4: null,
      inpIcon1: null,
      inpIcon2: null,
      inpIcon3: null,
      inpIcon4: null,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceFunctionDetail.categoryName,
      functionName: state => state.serviceFunctionDetail.functionName,

      // form
      serviceUuid: state => state.serviceFunctionDetail.serviceId,
      serviceFunctionUuid: state => state.serviceFunctionDetail.targetId,
      values: state => state.serviceFunctionDetail.values,
      deliveryType: state => state.serviceFunctionDetail.deliveryType,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // input
    inpJingleFile: {
      get () {
        return this.values.inpJingleFile
      },
      set (value) {
        this.setInputValue({
          key: 'inpJingleFile',
          value: value
        })
      }
    },
    inpSoundMessageFile: {
      get () {
        return this.values.inpSoundMessageFile
      },
      set (value) {
        this.setInputValue({
          key: 'inpSoundMessageFile',
          value: value
        })
      }
    },
    // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ST
    inpIsNoReplyNotificationEnabled: {
      get() {
        return this.values.inpIsNoReplyNotificationEnabled
      },
      set(value) {
        this.setInputValue({
          key: 'inpIsNoReplyNotificationEnabled',
          value: value
        })
      }
    },
    inpIsNoReplyMailNotification: {
      get() {
        return this.values.inpIsNoReplyMailNotification
      },
      set(value) {
        this.setInputValue({
          key: 'inpIsNoReplyMailNotification',
          value: value
        })
      }
    },
    inpIsNoReplyBotNotification: {
      get() {
        return this.values.inpIsNoReplyBotNotification
      },
      set(value) {
        this.setInputValue({
          key: 'inpIsNoReplyBotNotification',
          value: value
        })
      }
    },
    inpIsNoReplyDeviceNotification: {
      get() {
        return this.values.inpIsNoReplyDeviceNotification;
      },
      set(value) {
        this.setInputValue({
          key: "inpIsNoReplyDeviceNotification",
          value: value
        });
      }
    },
    inpMinDaysNoReplyNotification: {
      get() {
        return this.values.inpMinDaysNoReplyNotification
      },
      set(value) {
        this.setInputValue({
          key: 'inpMinDaysNoReplyNotification',
          value: value
        })
      }
    },
    inpIsReplyNotificationEnabled: {
      get() {
        return this.values.inpIsReplyNotificationEnabled
      },
      set(value) {
        this.setInputValue({
          key: 'inpIsReplyNotificationEnabled',
          value: value
        })
      }
    },
    inpIsReplyMailNotification: {
      get() {
        return this.values.inpIsReplyMailNotification
      },
      set(value) {
        this.setInputValue({
          key: 'inpIsReplyMailNotification',
          value: value
        })
      }
    },
    inpIsReplyBotNotification: {
      get() {
        return this.values.inpIsReplyBotNotification
      },
      set(value) {
        this.setInputValue({
          key: 'inpIsReplyBotNotification',
          value: value
        })
      }
    },
    inpIsReplyDeviceNotification: {
      get() {
        return this.values.inpIsReplyDeviceNotification;
      },
      set(value) {
        this.setInputValue({
          key: "inpIsReplyDeviceNotification",
          value: value
        });
      }
    },
    // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ED
    inpEnqueteMessage: {
      get () {
        return this.values.inpEnqueteMessage
      },
      set (value) {
        this.setInputValue({
          key: 'inpEnqueteMessage',
          value: value
        })
      }
    },
    inpEnqueteAnswers: {
      get () {
        return this.values.inpEnqueteAnswers
      },
      set (value) {
        this.setInputValue({
          key: 'inpEnqueteAnswers',
          value: value
        })
      }
    },
    inpMessageAftAnswers: {
      get () {
        return this.values.inpMessageAftAnswers
      },
      set (value) {
        this.setInputValue({
          key: 'inpMessageAftAnswers',
          value: value
        })
      }
    },
    // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ST
    // list
    noReplyNotificationEnabledList(){
      return Constants.Service.NoReplyNotificationEnabled.sort(Utility.sortByKey('index', true))
    },
    ReplyNotificationEnabledList(){
      return Constants.Service.ReplyNotificationEnabled.sort(Utility.sortByKey('index', true))
    },
    // validate
    inpMinDaysNoReplyNotificationIsValid() {
      if (this.inpIsNoReplyNotificationEnabled != undefined){
        if (this.inpIsNoReplyNotificationEnabled){
          if(!(/^\d+$/.test(this.inpMinDaysNoReplyNotification)))
            return false
          return parseInt(this.inpMinDaysNoReplyNotification) > 0
        }
        return true
      }
      return false
    },
    // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ED
    inpEnqueteMessageIsValid () {
      return Validator.validText(this.inpEnqueteMessage)
    },
    inpEnqueteAnswersIsValid () {
      return Validator.validText(this.inpAnswer1) &&
        Validator.validText(this.inpAnswer2) &&
        Validator.validFile(this.inpIcon1) &&
        Validator.validFile(this.inpIcon2)
    },
    inpMessageAftAnswersIsValid () {
      return Validator.validText(this.inpMessageAftAnswers)
    },
    inpReplyNotificationIsValid () {
      if (this.inpIsReplyNotificationEnabled != undefined){
        if (
          this.inpIsReplyNotificationEnabled &&
          !this.inpIsReplyMailNotification &&
          !this.inpIsReplyBotNotification &&
          !this.inpIsReplyDeviceNotification
        ) {
          return false
        }
        return true
      }
      return false
    },
    inpNoReplyNotificationIsValid () {
      if (this.inpIsNoReplyNotificationEnabled != undefined){
        if (
          this.inpIsNoReplyNotificationEnabled &&
          !this.inpIsNoReplyMailNotification &&
          !this.inpIsNoReplyBotNotification &&
          !this.inpIsNoReplyDeviceNotification
        ) {
          return false
        }
        return true
      }
      return false
    },
    formIsValid () {
      // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ST
      return this.inpEnqueteMessageIsValid &&
        this.inpEnqueteAnswersIsValid &&
        this.inpMessageAftAnswersIsValid &&
        this.inpMinDaysNoReplyNotificationIsValid &&
        this.inpReplyNotificationIsValid && 
        this.inpNoReplyNotificationIsValid
      // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ED
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    },
    inpIsNoReplyNotificationEnabled: function (to) {
      if (!to) {
        this.inpIsNoReplyMailNotification = false
        this.inpIsNoReplyBotNotification = false
        this.inpIsNoReplyDeviceNotification = false
      }
    },
    inpIsReplyNotificationEnabled: function (to) {
      if (!to) {
        this.inpIsReplyMailNotification = false
        this.inpIsReplyBotNotification = false
        this.inpIsReplyDeviceNotification = false
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
    }),
    ...mapMutations({
      setInputValue: 'serviceFunctionDetail/setInputValue',
    }),

    init () {
      this.inpEnqueteAnswers.forEach(item => {
        this['inpAnswer' + item.answerNo] = item.answerMessage
        this['inpIcon' + item.answerNo] = item.iconFile
      })

      this.loading = false
    },
    turnBack () {
      this.$router.push({
        name: 'ServiceFunction',
        params: {
          serviceId: this.serviceUuid
        }
      })
    },

    // 選択肢設定
    enableChoices (no) {
      return !Validator.validText(this['inpAnswer' + no])
    },

    postData () {
      this.processing = true

      // jsonb : FunctionFollow(見守り機能)
      let jsonb = {
        // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ST
        isNoReplyNotificationEnabled: this.inpIsNoReplyNotificationEnabled,
        // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ED
        enqueteMessage: this.inpEnqueteMessage,
        enqueteAnswers: this.inpEnqueteAnswers,
        messageAftAnswers: this.inpMessageAftAnswers,
        isReplyNotificationEnabled: this.inpIsReplyNotificationEnabled
      }
      // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ST
      if (this.inpIsNoReplyNotificationEnabled) {
        const inpMinDaysNoReplyNotificationNum = parseInt(this.inpMinDaysNoReplyNotification)
        if (isNaN(inpMinDaysNoReplyNotificationNum)) {
          jsonb.minDaysNoReplyNotification = this.inpMinDaysNoReplyNotification
        } else {
          jsonb.minDaysNoReplyNotification = inpMinDaysNoReplyNotificationNum
        }
      }
      jsonb.isNoReplyMailNotification = this.inpIsNoReplyMailNotification
      jsonb.isNoReplyBotNotification = this.inpIsNoReplyBotNotification
      jsonb.isNoReplyDeviceNotification = this.inpIsNoReplyDeviceNotification
      // 202305 機能設定の「見守り機能」に「見守り未回答通知設定」を追加 ED
      jsonb.isReplyMailNotification = this.inpIsReplyMailNotification
      jsonb.isReplyBotNotification = this.inpIsReplyBotNotification
      jsonb.isReplyDeviceNotification = this.inpIsReplyDeviceNotification
      // ジングル音
      if (this.inpJingleFile) {
        jsonb.jingleFile = Jsonb.requestFile(this.values.jingleFile, this.inpJingleFile)
      }
      // 音声メッセージ
      if (this.inpSoundMessageFile) {
        jsonb.soundMessageFile = Jsonb.requestFile(this.values.soundMessageFile, this.inpSoundMessageFile)
      }
      // 選択肢設定
      for (let i = 0, n = 1, l = 4; i < l; i++, n++) {
        if (this['inpAnswer' + n]) {
          if (!i) jsonb.enqueteAnswers = []
          let answerItem = {
            answerNo: n,
            answerMessage: this['inpAnswer' + n]
          }
          if (this['inpIcon' + n]) {
            answerItem.iconFile = Jsonb.requestFile(this.values.enqueteAnswers[i] 
              ? this.values.enqueteAnswers[i].iconFile 
              : null, this['inpIcon' + n])
          }
          jsonb.enqueteAnswers.push(answerItem)
        } else {
          break
        }
      }

      // リクエストパラメータ
      let parameters = {
        serviceUuid: this.serviceUuid,
        serviceFunctionUuid: this.serviceFunctionUuid,
        request: {
          followSetting: jsonb
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.functionName + '情報の登録',
              body: this.functionName + '情報を登録しました。',
            })

            // 一覧へリダイレクト
            this.turnBack()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    confirmData () {
      // validate
      if (this.formIsValid) {
        // confirm
        this.showConfirm({
          key: 'register',
          title: '',
          body: 'この' + this.functionName + '情報を登録しますか？'
        })
      }
    },

    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      console.log('changeFileFromSelector', props)
      this.setInputValue({
        key: props.name,
        value: Jsonb.formatFile(props.data)
      })
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      console.log('deleteFileFromSelector', props)
      this.setInputValue({
        key: props.name,
        value: null
      })
    },

    /**
     * ファイルの変更
     */
    changeIconFileFromSelector (props) {
      console.log('changeIconFileFromSelector', props)
      this.$set(this, props.name, Jsonb.formatFile(props.data))
    },
    /**
     * ファイルの削除
     */
    deleteIconFileFromSelector (props) {
      console.log('deleteIconFileFromSelector', props)
      this.$set(this, props.name, null)
    }

  }
}
